import React, { useState } from 'react';
import '../home/Home.css';

export default function Rules({ setDisplay }) {
  // List of rules
  const [rules] = useState([
    'You start the game with $100.',
    'You must choose to bet an amount of at least $10 to be dealt your cards.',
    'The dealer and you will both be dealt 2 cards - you can see all of your cards but you can only see one of the dealers.',
    'You are given two options - hit and stand. If you choose to hit, you will be dealt 1 more card. If you choose to stand, you will not be dealt any more cards.',
    'Like traditional Blackjack, your goal is to beat the dealer\'s hand. The maximum valid value is 21, if you end up with a value of over 21, it is called a bust.',
    'Unique to 493Jack, if you end up with exactly a 4, a 9, and a 3 in your hand, you will automatically win 5x your bet. This is called 493Jack and it trumps 21.',
    'If you beat the dealer, you will be given the amount you bet. If you lose to the dealer, you will lose the amount you bet. If you tie, your bet will be returned to you.',
    'If you run out of money, you lose the game and your name and money will not show up on the leaderboard.',
    'You may quit at any time and your current amount of money will show up on the leaderboard.',
  ])

  return (
    <div className='rules-content'>
      <div className='home-title'>
        <button className='next-button' onClick={() => setDisplay('home')}>
          <i className='fa fa-times'></i>
        </button>
        <h1>
          <strong>
            <span className='black'>493</span><span className='red'>jack </span>
            Rules
          </strong>
        </h1>
      </div>

      <div className='rules-scroll'>
        <ol>
          {rules.map(rule => <li>{rule}</li>)}
        </ol>
      </div>
    </div>
  )
}
